<div class="p-4">
    <h5>Informações de ajuda</h5>
    <br>
    <p>Para ser feita a vincução do cartão físico precisaremos de algumas informações.</p>
    <br>
    <ul>
        <li>
            É necessário que insira o número do cartão
            <!-- que está no verso do cartão-->.
            <!-- <img src="./assets/icons/HelpCard.svg" width="50%"> -->
            <!-- <br> -->
        </li>
        <li>
            É necessário que insira o endereço do favorecido.
        </li>
        <li>
            Precisamos que envie fotos do favorecido e seus documentos para que seja comprovada a entrega do cartão a pessoa recebedora.
        </li>
        <li>
            Caso haja inconsistência dos documentos informados, o cartão e a conta podem ser desativadas pelo sistema posteriormente.
        </li>
        <li>
            Certifique-se que o telefone do favorecido está correto.
        </li>
        <li>
            A senha do cartão do favorecido será gerada automaticamente pelo sistema.
        </li>
        <li>
            A senha será enviada através de um SMS para o telefone cadastrado do favorecido.
        </li>
        <li>
            Se o favorecido já tem um cartão, o atual será desativado.
        </li>
        <!-- Todos os pontos onde estiverem favorecido vai mudar para o que for dependendo do tipo dele     -->
    </ul>

    <p></p>
</div>
